import React from "react";
import {BasicViewPage} from "./BasicViewPage";

export const TsvViewPage = () => {

    return <BasicViewPage type={"TSV"} />

}